import { useTranslation } from 'react-i18next'

import { clsx } from 'clsx'

import { Button } from '@dfds-pax/shared-components/client'

import { ProductListSections } from '../../../api/travel-search-config'
import { ActiveSelectField, useActiveSelectField } from '../../context/ActiveSelectFieldProvider'
import { useTravelSearchContext } from '../../context/TravelSearchProvider'
import OnewayReturn from '../oneway-return/OnewayReturn'
import { OfferSelector } from './OfferSelector'

interface Props {
  onProductClicked: (minibookId: string) => void
  optionalOfferTitle?: string
  productLists: ProductListSections[]
  route: string
}

const MultiOffer: React.FC<Props> = ({ onProductClicked, optionalOfferTitle, productLists }) => {
  const { t } = useTranslation()
  const { dispatch, state } = useTravelSearchContext()
  const { toggleField, travelSearchInViewport } = useActiveSelectField()

  return (
    <div className="flex w-full bg-transparent">
      <div className="flex w-full">
        <div className={`z-[5000] flex w-full md:max-w-[500px] ${travelSearchInViewport ? 'w-full bg-transparent' : 'bg-transparent'}`}>
          <div className="flex w-full flex-col gap-0 md:gap-semantic-global-xs">
            <div aria-hidden="true" className="invisible bg-transparent hidden md:block">
              <OnewayReturn onewayDisabled={false} />
            </div>
            <div className={clsx('flex w-full flex-col items-center gap-primitive-8 md:flex-row md:gap-0')}>
              <OfferSelector
                onProductClicked={(minibookId: string, offerTitle: string) => {
                  toggleField(ActiveSelectField.NONE, false)
                  dispatch({
                    selectedMultiOffer: {
                      minibookId: minibookId,
                      offerTitle: offerTitle,
                    },
                    type: 'SET_MULTI_OFFER',
                  })

                  onProductClicked(minibookId)
                }}
                optionalOfferTitle={optionalOfferTitle}
                products={productLists}
                selectedMultiOffer={state.selectedMultiOffer}
              />
              <div
                data-e2e="multiofferButtonContainer"
                className="ml-auto w-full border border-solid border-semantic-global-primary-default md:w-[150px]"
              >
                <Button fullWidth onClick={() => toggleField(ActiveSelectField.MULTI_OFFER, false)} size="lg">
                  {t('SEE-OFFERS')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MultiOffer

export interface ProductList {
  description: string
  products: Product[]
}
export interface Product {
  minibookId: string
  offerDetails: string
  productDetails: string
  title: string
}
